import { useSyncExternalStore } from "react";
import { BREAKPOINTS, breakpointForWidth, type Breakpoint } from "./types";

// Each breakpoint boundary; crossing one is the only width change that matters.
const QUERIES = [
  `(min-width: ${BREAKPOINTS.tablet.min}px)`,
  `(min-width: ${BREAKPOINTS.desktop.min}px)`,
];

function subscribe(onChange: () => void): () => void {
  if (typeof window === "undefined" || !window.matchMedia) return () => {};
  const lists = QUERIES.map((q) => window.matchMedia(q));
  lists.forEach((l) => l.addEventListener("change", onChange));
  return () => lists.forEach((l) => l.removeEventListener("change", onChange));
}

function getSnapshot(): Breakpoint {
  return breakpointForWidth(window.innerWidth);
}

function getServerSnapshot(): Breakpoint {
  return "desktop";
}

/**
 * The breakpoint of the visitor's browser window, kept current as it resizes.
 * The published site passes it to DocumentRenderer so tablet and mobile
 * overrides apply there just as they do in the editor's viewport preview.
 */
export function useViewportBreakpoint(): Breakpoint {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
